/* Collection discovery only; native Shopify filters, sorting and cart forms remain authoritative. */
(() => {
 const normalize = value => value.normalize('NFD').replace(/\p{M}/gu, '').toLocaleLowerCase();
 const mount = scope => scope.querySelectorAll('[data-bgc-catalog]').forEach(root => {
  if (root.dataset.bgcReady) return;
  root.dataset.bgcReady = 'true';
  const form = root.querySelector('[data-bgc-discovery-form]');
  const input = form.querySelector('[type="search"]');
  const grid = root.querySelector('[data-bgc-grid]');
  const status = root.querySelector('[data-bgc-status]');
  const empty = root.querySelector('[data-bgc-empty]');
  const pagination = root.querySelector('[data-bgc-pagination]');
  const featured = root.querySelector('[data-bgc-featured]');
  const original = grid.innerHTML;
  const originalStatus = status.textContent;
  const total = Number(grid.dataset.total);
  const filterPanel = root.querySelector('.bgc-filters');
  const media = matchMedia('(min-width: 900px)');
  const responsive = () => { if (filterPanel) filterPanel.open = media.matches; };
  responsive(); media.addEventListener('change', responsive);
  root.querySelector('[data-bgc-search]').hidden = false;
  root.querySelector('.bgc-sort-apply').hidden = true;
  const viewControls = root.querySelector('[data-bgc-view-controls]');
  const applyView = view => {
   grid.classList.toggle('bgc-list', view === 'list');
   viewControls?.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bgcView === view)));
  };
  if (viewControls) {
   viewControls.hidden = false;
   try { applyView(sessionStorage.getItem('bgc-view') || 'grid'); } catch (_) { /* Storage can be disabled. */ }
   viewControls.addEventListener('click', e => { const b=e.target.closest('[data-bgc-view]'); if(!b)return; applyView(b.dataset.bgcView);try{sessionStorage.setItem('bgc-view',b.dataset.bgcView);}catch(_){} });
  }
  let controller, generation = 0, cached;
  const cleanURL = value => {
   const url = new URL(value, location.href);
   if (url.origin !== location.origin || url.pathname !== new URL(root.dataset.collectionUrl, location.href).pathname) throw Error('Unexpected collection page');
   url.searchParams.delete('bgc_q');
   url.searchParams.set('section_id', root.dataset.sectionId);
   return url;
  };
  const collect = async (signal, token) => {
   if (cached) return cached;
   const cards = new Map();
   let currentGrid = grid;
   let next;
   if (Number(grid.dataset.page) !== 1) { const first=cleanURL(location.href);first.searchParams.set('page','1');next=first.href;currentGrid=null; }
   const visited = new Set();
   while (true) {
    if (signal.aborted || token !== generation) throw new DOMException('Cancelled', 'AbortError');
    if (currentGrid) {
     currentGrid.querySelectorAll('[data-bgc-card]').forEach(card => cards.set(card.dataset.productId, card.cloneNode(true)));
     if (token === generation) status.textContent = `${root.dataset.searchLoading} ${cards.size} / ${total}`;
     next = currentGrid.dataset.next;
    }
    if (!next) break;
    const url = cleanURL(next);
    if (visited.has(url.href)) throw Error('Repeated collection page');
    visited.add(url.href);
    const timer = setTimeout(() => { if(token===generation) controller.abort(); }, 20000);
    try {
     const response = await fetch(url.href, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
     if (!response.ok) throw Error('Collection request failed');
     const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
     currentGrid = doc.querySelector('[data-bgc-grid]');
     if (!currentGrid || Number(currentGrid.dataset.total) !== total) throw Error('Collection changed; retry search');
    } finally { clearTimeout(timer); }
   }
   if (cards.size !== total) throw Error('Incomplete collection results');
   cached = [...cards.values()];
   return cached;
  };
  const runSearch = async (updateURL = true) => {
   controller?.abort(); controller = new AbortController();
   const token = ++generation;
   const query = input.value.trim();
   if (updateURL) { const url=new URL(location.href);if(query)url.searchParams.set('bgc_q',query);else url.searchParams.delete('bgc_q');history.pushState(null,'',url); }
   if (!query) { grid.innerHTML=original;status.textContent=originalStatus;pagination.hidden=false;empty.hidden=total>0;if(featured)featured.hidden=false;root.removeAttribute('aria-busy');return; }
   if (featured) featured.hidden=true;
   status.textContent=root.dataset.searchLoading;
   root.setAttribute('aria-busy','true');
   try {
    const cards=await collect(controller.signal,token);
    if(token!==generation)return;
    const words=normalize(query).split(/\s+/).filter(Boolean);
    const matches=cards.filter(card=>words.every(word=>normalize(card.dataset.search).includes(word)));
    grid.replaceChildren(...matches.map(card=>card.cloneNode(true)));
    status.textContent=`${matches.length} ${root.dataset.searchResults}`;
    pagination.hidden=true;empty.hidden=matches.length>0;
   } catch (_) {
    if(token!==generation)return;
    grid.innerHTML=original;pagination.hidden=false;empty.hidden=total>0;status.textContent=root.dataset.searchError;
   } finally { if(token===generation)root.removeAttribute('aria-busy'); }
  };
  form.addEventListener('submit',event=>{
   if(event.submitter?.matches('[data-bgc-search-submit]') || (!event.submitter && document.activeElement===input)){event.preventDefault();runSearch();}
  });
  form.querySelector('[name="sort_by"]').addEventListener('change',()=>form.requestSubmit());
  input.addEventListener('input',()=>{if(!input.value)runSearch();});
  const restoreSearch=()=>{input.value=new URL(location.href).searchParams.get('bgc_q')||'';runSearch(false);};
  const initial=new URL(location.href).searchParams.get('bgc_q');
  if(initial){input.value=initial;runSearch(false);}
  addEventListener('popstate',restoreSearch);
  (root.closest('.shopify-section')||root).addEventListener('shopify:section:unload',()=>{generation++;controller?.abort();media.removeEventListener('change',responsive);removeEventListener('popstate',restoreSearch);},{once:true});
 });
 mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
